import { Layers } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LayersIcon = createLucideIcon(Layers);
